import React, { useRef, useState } from "react";
import useClosePopUp from "../hooks/useClosePopUp";
import months from "../utils/monthsList";
import PoleSvg from "./PoleSvg";

export interface MonthAndYearDdT {
  monthsRange: string;
  handleMonthChange: (month: number) => void;
  currentDate: Date;
  setCurrentDate: React.Dispatch<React.SetStateAction<Date>>;
  showYearMonthDivider?: boolean;
}

function MonthAndYearDd({
  monthsRange,
  handleMonthChange,
  currentDate,
  setCurrentDate,
  showYearMonthDivider,
}: MonthAndYearDdT) {
  const [isMonthDropdownVisible, setIsMonthDropdownVisible] = useState(false);
  const [yearInput, setYearInput] = useState(String(currentDate.getFullYear()));

  const inputRef = useRef<HTMLInputElement | null>(null);
  const dropdownRef = useRef<HTMLInputElement | null>(null);

  const handleYearInputChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = event.target.value;
    if (/^\d{0,4}$/.test(value)) {
      setYearInput(value);
      if (value.length === 4) {
        setCurrentDate(
          (prev: Date) => new Date(Number(value), prev.getMonth(), 1)
        );
      }
    }
  };

  useClosePopUp(isMonthDropdownVisible, inputRef, setIsMonthDropdownVisible);

  return (
    <div className="flex gap-2 items-center">
      <div className="block relative">
        <input
          ref={inputRef}
          type="text"
          value={monthsRange}
          className="text-center w-24 text-sm border rounded bg-white py-2 cursor-pointer"
          readOnly
          onClick={() => {
            setIsMonthDropdownVisible(true);
          }}
        />
        {isMonthDropdownVisible && (
          <div
            style={{
              animation: isMonthDropdownVisible
                ? "fadeInSlideIn 0.2s ease-out"
                : "fadeOutSlideOut 0.2s ease-out",
            }}
            ref={dropdownRef}
            className={`dropdown max-h-64 my-2 transition-all duration-200 ease-in-out absolute top-10 left-0 bg-white h-72 overflow-y-auto flex flex-col w-full shadow-xl`}
          >
            {months.map((month, index) => (
              <button
                key={month}
                className="py-2 text-sm text-gray-700 hover:bg-slate-100 duration-200 ease-in-out transition-colors"
                onClick={() => handleMonthChange(index)}
              >
                {month}
              </button>
            ))}
          </div>
        )}
      </div>

      {showYearMonthDivider && (
        <span data-testid="yearMonthDivider">
          <PoleSvg />
        </span>
      )}

      <input
        type="number"
        value={yearInput}
        onChange={handleYearInputChange}
        className="w-20 p-2 text-sm border rounded bg-white text-center"
        placeholder="Year"
      />
    </div>
  );
}

export default MonthAndYearDd;
